import { memo } from 'react';

import styles from './TooltipInfo.scss';

interface TooltipInfoProps {
  children: string;
}

const TooltipInfo = ({ children }: TooltipInfoProps) => {
  return <div className={styles.info} dangerouslySetInnerHTML={{ __html: children }} />;
};

export default memo(TooltipInfo);
